import { render, staticRenderFns } from "./UserProfileUpdate.vue?vue&type=template&id=29ecf355&scoped=true&"
import script from "./UserProfileUpdate.vue?vue&type=script&lang=js&"
export * from "./UserProfileUpdate.vue?vue&type=script&lang=js&"
import style0 from "./UserProfileUpdate.vue?vue&type=style&index=0&id=29ecf355&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ecf355",
  null
  
)

export default component.exports